import Api from "../../../Api"

/**
 *
 * @param {*} filter
 * @returns
 */
export function queryComplementosPago(filter = {}) {
  return Api.query({
    model: "ComComplementoPago",

    attributes: [
      'iId',
      'sCfdiUUID',
      'dFecha'
    ],

    include: [
      { as: "archivoXml", attributes: ["sDescripcion"] },
      { as: "archivoPdf", attributes: ["sDescripcion"] },
    ],

    where: {
      iActivo: true,
      iIdProveedor: Api.getProviderId(),
      ...filter,
    },

    order: [
      ["iId", "DESC"]
    ]
  })
}
